"use client";
import "./imagetext.scss";
import { Heading, TextAttr, AdvancedImageAttr, SelectAttr, useAttrValue } from "@/core/blocks/attributes";

/** Image + text block; the image side is chosen in the page builder. */
export default function ImageTextBlock() {
  const side = useAttrValue("side", "left");
  return (
    <section className={`block-imagetext side-${side}`}>
      <div className="container imagetext-grid">
        <SelectAttr
          name="side"
          options={[
            { value: "left", label: "Image left" },
            { value: "right", label: "Image right" },
          ]}
        />
        <div className="imagetext-media">
          <AdvancedImageAttr name="image" className="imagetext-img" sizes="(min-width: 900px) 50vw, 100vw" />
        </div>
        <div className="imagetext-body">
          <Heading name="title" className="section-title" placeholder={{ nl: "Titel", en: "Title" }} />
          <TextAttr name="text" rich as="div" className="imagetext-text" placeholder={{ nl: "Vertel je verhaal…", en: "Tell your story…" }} />
        </div>
      </div>
    </section>
  );
}

export const meta = { label: "Image + text", icon: "vertical_split" };

export function defaults(): Record<string, unknown> {
  return { side: "left", title: {}, text: {} };
}
